<section [class]="cardLayoutClass" [ngClass]="{selected:isSelected$|async}">
  <header [ngClass]="headerCss">
    <section class="card-title">
      <span *ngFor="let title of titles; let i = index"
            [ngClass]="'level-'+i">
        <ng-container [ngSwitch]="title.type">
          <a *ngSwitchCase="'link'"
             class="link"
             target="_blank"
             [href]="title.link">{{title.text}}</a>
          <span *ngSwitchDefault>{{title.text}}</span>
        </ng-container>
      </span>
    </section>
    <gen-toggle-switch
      *ngIf="selectable"
      [active]="isSelected$|async"
      (statusUpdate)="selectUpdated($event)"
    ></gen-toggle-switch>
  </header>
  <section class="card-content">
    <gen-dynamic-form
      [formName]="identifier"
      [formConfig]="shortFormConfig"
      [disabled]="true"
      [editMode]="true"
      [formData]="data"
      [formItemFullWidth]="isFullWidth"
      [formVertical]="isVertical"
    ></gen-dynamic-form>

    <span class="more-info link" *ngIf="!hideMoreInfo" (click)="showMoreInfo()">{{'More Info' | stringTranslate}}</span>
  </section>
</section>
